export default __webpack_public_path__ + "static/media/704.96e21103.png";